import { render, staticRenderFns } from "./PassengerRight.vue?vue&type=template&id=2d875750&scoped=true"
import script from "./PassengerRight.vue?vue&type=script&lang=js"
export * from "./PassengerRight.vue?vue&type=script&lang=js"
import style0 from "./PassengerRight.vue?vue&type=style&index=0&id=2d875750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d875750",
  null
  
)

export default component.exports